import React from 'react';
import Button from '@components-clean/core/button';
import { EditCardProps, IDisabledButtonDetails } from '@components-clean/core/edit-card/edit-card.interface';
import Card from 'views-clean/components/core/card';
import { useTranslation } from '@hooks/index';

const EditCard = ({
    title,
    isEditMode,
    onEdit,
    onSave,
    onCancel,
    children,
    disabled,
    'data-testid': testDataId,
    onDelete,
    disabledDelete = false,
    saveDisabled = false,
    ...rest
}: EditCardProps) => {
    const { t } = useTranslation();

    const editDisabledButtonDetails = disabled as IDisabledButtonDetails;

    return (
        <Card
            title={title}
            headerActions={
                <>
                    {isEditMode && (
                        <div style={{ display: 'flex', gap: '2px' }}>
                            <Button
                                data-testid={`${testDataId}-cancel-button`}
                                onClick={() => {
                                    onCancel();
                                }}
                            >
                                {t('cancel')}
                            </Button>
                            <Button
                                data-testid={`${testDataId}-save-button`}
                                disabled={saveDisabled}
                                primary
                                onClick={() => {
                                    onSave();
                                }}
                            >
                                {t('save')}
                            </Button>
                        </div>
                    )}
                    {!isEditMode && (
                        <div style={{ display: 'flex', gap: '2px' }}>
                            {onDelete && (
                                <Button
                                    data-testid={`${testDataId}-delete-button`}
                                    disabled={disabledDelete}
                                    onClick={() => {
                                        onDelete();
                                    }}
                                >
                                    {t('delete')}
                                </Button>
                            )}
                            <Button
                                data-testid={`${testDataId}-edit-button`}
                                disabled={!!disabled}
                                primary
                                onClick={() => {
                                    onEdit();
                                }}
                                tooltip={editDisabledButtonDetails?.tooltip}
                            >
                                {editDisabledButtonDetails?.button?.text ?? t('edit')}
                            </Button>
                        </div>
                    )}
                </>
            }
            data-testid={testDataId}
            {...rest}
        >
            {children}
        </Card>
    );
};

export default EditCard;
